import React from 'react';
import PropTypes from 'prop-types';
import { area } from 'd3-shape';
import styles from './area.module.scss';

const Area = ({ stream, xScale, yScale, height, clipPath, fill }) => {
  const formatData = stream.convertedElevation.map((elev, index) => ({
    elev,
    dist: stream.convertedDistance[index]
  }));

  const drawArea = area()
    .x((d) => xScale(d.dist))
    .y1((d) => yScale(d.elev))
    .y0(height);

  return (
    <g className="AreaGroup" clipPath={clipPath}>
      <path className={styles.area} fill={fill} d={drawArea(formatData)} />
    </g>
  );
};

Area.propTypes = {
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired,
  stream: PropTypes.shape().isRequired,
  clipPath: PropTypes.string,
  fill: PropTypes.string
};

Area.defaultProps = {
  clipPath: null,
  fill: 'rgba(100, 100, 100, 0.66)'
};

export default Area;
